import { render } from "./AttributeParamsMoudule.vue?vue&type=template&id=9d0371d6&scoped=true"
import script from "./AttributeParamsMoudule.vue?vue&type=script&lang=js"
export * from "./AttributeParamsMoudule.vue?vue&type=script&lang=js"

import "./AttributeParamsMoudule.vue?vue&type=style&index=0&id=9d0371d6&lang=scss&scoped=true"

import exportComponent from "G:\\ElectronicPointOfSales\\Mang.EposApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d0371d6"]])

export default __exports__